// extracted by mini-css-extract-plugin
export default {"root":"NotAvailable-root-3052ca45c315a789807bd675368b9235"};